import React from "react";
import { Route } from "react-router-dom";
import routes from "..";

export default function renderRoutes() {
  return (
    <>
      {routes.map((el) => (
        <Route path={el.path} element={el.component} />
      ))}
    </>
  );
}
